import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FlightType, IFlight } from '../../../model/flights';
import FlightsActions from './store/flights.action-types';
import { FlightsState } from './store/flights.reducers';
import { flightsLimitedSelector, flightsSelector } from './store/flights.selectors';

@Injectable({
    providedIn: 'root'
})
export class FlightsService {
    constructor(private readonly store: Store<FlightsState>) {}

    requestFlights(centerlineIds: string[]) {
        this.store.dispatch(FlightsActions.requestFlights({ centerlineIds }));
    }

    loadFlights(flights: IFlight[]) {
        this.store.dispatch(FlightsActions.loadFlights({ flights }));
    }

    getFlights(): Observable<IFlight[]> {
        return this.store.select(flightsSelector);
    }

    getFlightsLimited(count: number): Observable<IFlight[]> {
        return this.store.select(flightsLimitedSelector, { count });
    }

    getFlightTypeIconName(flightType: FlightType): string {
        let iconName: string;
        switch (flightType) {
            case FlightType.Arrival:
                iconName = 'flight_land';
                break;
            case FlightType.Departure:
                iconName = 'flight_takeoff';
                break;
            case FlightType.TowInMovement:
                iconName = 'flight_tow_in';
                break;
            case FlightType.TowOutMovement:
                iconName = 'flight_tow_out';
                break;
            default:
                break;
        }
        return iconName;
    }
}
